import { useContext } from 'react'

import { AsyncSelect } from 'genesis-suite/components'
import { userService } from '../../lib/services'
import { phoneRegexp } from '../../lib/yupSchemas'
import { CloudContext } from '../contexts/CloudContext'

export default function UserSearchSelect({ onChange, noUsersOption: NoOptionComponent }) {
    const { selectedCloud } = useContext(CloudContext)
    const handleOptionsRequest = async searchText => {
        const usersFetchRequest = {
            ModelName: selectedCloud,
            PageSize: 100,
            PageNumber: 1,
            loaddetails: true,
            superUsersOnly: false,
            userIdSearch: searchText,
        }
        const foundUsers = await userService.userSearch(usersFetchRequest)

        if (!foundUsers) return { options: [], totalRecords: 0 }

        const res = await userService.getUsersV2(usersFetchRequest)

        const users = res?.users ?? []
        const newUserList = foundUsers
            ?.filter(user => users.findIndex(u => u.userInfo?.userId === user.userId) === -1)
            ?.map(user => ({ label: `${user.fullName}(${user.userId})`, value: user.userId }))

        return { options: newUserList }
    }

    const handleSelect = async username => {
        const user = await userService.getUserById(username)
        if (!user || !user.userInfo) return
        const { firstName, lastName, userId, email, isExternal, phone, companyId, domainId } = user.userInfo
        const correctedPhone = phone.match(phoneRegexp) ? phone : ''

        const userObject = {
            firstName,
            lastName,
            userId,
            email,
            isExternal,
            phone: correctedPhone,
            companyId,
            domainId,
        }
        Object.keys(userObject).forEach(name => {
            onChange({ target: { name, value: userObject[name] } })
        })
    }

    return (
        <AsyncSelect
            debug
            disableClearable
            requestStart="text"
            textFieldProps={{ placeholder: 'Search for a user', autoFocus: true, onFocus: e => e.target.select() }}
            onOptionsRequest={handleOptionsRequest}
            onChange={(e, { value }) => handleSelect(value)}
            noOptionsText={<NoOptionComponent />}
        />
    )
}
